<mat-list
  igoClickout
  [ngClass]="{ selectable: selection }"
  (clickout)="disableNavigation()"
  (click)="enableNavigation()"
>
  <ng-content />
</mat-list>
